import request from "@/utils/request";

export default function agentBindCardForWeChat(card) {
    return request({
        url: `/user/card/agettToReportTheLossOfCard/${card}`,
        method: 'post',
    })
}
